// extracted by mini-css-extract-plugin
export default {"textLink":"ViewInTable_textLink__e4Y75"};